import React                from "react";
import PropTypes            from "prop-types";
import Action               from "Dashboard/Core/Action";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";
import Commons              from "Utils/Commons";

// Components
import PageEdit             from "./PageEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Page List
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function PageList(props) {
    const { type } = props;
    const { fetch, load } = useList("page", type);

    const activityID = Commons.useActivityID();

    const data = Store.useState("page");
    const { loading, canEdit, list, total, sort } = data;

    const { deleteElem } = Store.useAction("page");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "pageID", elemID, "name");

    return <Main>
        <Header message="PAGES_NAME" icon="page">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="PAGES_NONE_AVAILABLE"
                isLoading={loading}
                hasTabs
            >
                <TableHead>
                    <TableHeader field="name"         message="GENERAL_NAME"            isTitle />
                    <TableHeader field="status"       message="GENERAL_STATUS"          align="center" maxWidth="100" />
                    <TableHeader field="modifiedTime" message="GENERAL_MODIFIED_AT_FEM" minWidth="160" maxWidth="160" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.pageID} elemID={elem.pageID}>
                        <TableCell message={elem.name}             />
                        <TableCell message={elem.statusName}       textColor={elem.statusColor} />
                        <TableCell message={elem.modifiedTimeDate} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="PAGES_EDIT_TITLE"   />
                    <TableAction action="COPY"   message="PAGES_COPY_TITLE"   />
                    <TableAction action="DELETE" message="PAGES_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <PageEdit
            open={action.isVCCE}
            isCopy={action.isCopy}
            elemID={elemID}
            activityID={activityID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="PAGES_DELETE_TITLE"
            message="PAGES_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
PageList.propTypes = {
    type : PropTypes.string.isRequired,
};

export default PageList;
